import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import srTranslation from './translations/rs';
import hrTranslation from './translations/hr';
import baTranslation from './translations/ba';

const resources = {
  rs: {
    translation: srTranslation,
  },
  hr: {
    translation: hrTranslation
  },
  ba: {
    translation: baTranslation
  }
};

const currentTranslation = () => {
  const path = window.location.pathname;
  const pathMatch = path.match(/^\/([a-z]{2})\//);
  const urlLocale = pathMatch ? pathMatch[1] : null;
  
  const validLocales = ['hr', 'rs', 'ba'];
  
  if (urlLocale && validLocales.includes(urlLocale)) {
    localStorage.setItem('translation', urlLocale);
    return urlLocale;
  }
  
  if (path === '/' || path === '') {
    const defaultLocale = 'hr';
    localStorage.setItem('translation', defaultLocale);
    return defaultLocale;
  }
  
  const storedLocale = localStorage.getItem('translation');
  if (storedLocale && validLocales.includes(storedLocale)) {
    return storedLocale;
  }
  
  localStorage.setItem('translation', 'hr');
  return 'hr';
};

i18n.use(initReactI18next).init({
  resources,
  lng: currentTranslation(),
  fallbackLng: 'hr',

  interpolation: {
    escapeValue: false,
  },
});

const syncLanguageWithURL = () => {
  const path = window.location.pathname;
  const pathMatch = path.match(/^\/([a-z]{2})\//);
  const urlLocale = pathMatch ? pathMatch[1] : null;
  const validLocales = ['hr', 'rs', 'ba'];
  
  if (urlLocale && validLocales.includes(urlLocale)) {
    if (i18n.language !== urlLocale) {
      i18n.changeLanguage(urlLocale);
      localStorage.setItem('translation', urlLocale);
    }
  }
};

if (typeof window !== 'undefined') {
  syncLanguageWithURL();
  setTimeout(syncLanguageWithURL, 0);
  setTimeout(syncLanguageWithURL, 50);
  setTimeout(syncLanguageWithURL, 100);
  setTimeout(syncLanguageWithURL, 200);
  
  const browserHistory = window.history;
  const originalPushState = browserHistory.pushState;
  const originalReplaceState = browserHistory.replaceState;
  
  browserHistory.pushState = function() {
    originalPushState.apply(browserHistory, arguments);
    setTimeout(syncLanguageWithURL, 0);
  };
  
  browserHistory.replaceState = function() {
    originalReplaceState.apply(browserHistory, arguments);
    setTimeout(syncLanguageWithURL, 0);
  };
  
  window.addEventListener('popstate', syncLanguageWithURL);
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncLanguageWithURL);
  }
}

export default i18n;
